import { Component, ReactNode } from "react";
import { NewConnection } from "../../components/NewConnection/NewConnection";
import "./ListConnectionsContainer.scss";

export default class ListConnectionsContainer extends Component<{}, {}> {
  render(): ReactNode {
    return (
      <div className={"list-connections-container"}>
        <div className={"list-connections-container_connections"}>
          <ul className={"list-connections-container_connections_list"}></ul>
        </div>
        <div className={"list-connections-container_new-connection"}>
          <NewConnection />
        </div>
      </div>
    );
  }
}
